<template>
  <div class="infoCenter">
    <div class="title" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1>{{titleName === 'company' ? '企业动态' : '行业动态'}}</h1>
    </div>
    <div class="middle-content">
      <transition name="fade-transform" mode="out-in" v-if="newsList.length>0">
        <div class="info-content">
        <div class="info-tab">
          <ul>
            <li @click="goTab('company')" :class="{canClick: titleName === 'company'}">企业动态</li>
            <li class="short-line"></li>
            <li @click="goTab('pig')" :class="{canClick: titleName === 'pig'}">行业动态</li>
          </ul>
        </div>

        <div class="hot-news">
          <div class="group-l" :style="`background-image:url(${newsOne.pictureUrl})`" @click="goDetail(newsOne)">
            <div class="wrap-1">
              <div class="box">
                <h2>{{newsOne.articleTitle}}</h2>
                <p>{{newsOne.releaseTime|formatDate}}</p>
              </div>
            </div>
          </div>
          <div class="group-r">
            <div class="item" @click="goDetail(newsTwo)">
              <div class="item-left" :style="`background-image:url(${newsTwo.pictureUrl})`"></div>
              <div class="item-right">
                <h2>{{newsTwo.articleTitle}}</h2>
                <p>{{newsTwo.releaseTime|formatDate}}</p>
              </div>
            </div>
            <div class="item-line"></div>
            <div class="item" @click="goDetail(newsThree)">
              <div class="item-left" :style="`background-image:url(${newsThree.pictureUrl})`"></div>
              <div class="item-right">
                <h2>{{newsThree.articleTitle}}</h2>
                <p>{{newsThree.releaseTime|formatDate}}</p>
              </div>
            </div>
          </div>
        </div>
        <section class="news-list">
          <ul>
            <li class="list-box" v-for="(item, index) in newsList" :key="index+'newFirst'" @click="goDetail(item)" v-show="currentPage===1 && index>2">
              <img :src="item.pictureUrl" alt="">
              <div class="con">
                <h2>{{item.articleTitle}}</h2>
                <p>{{item.releaseTime|formatDate}}</p>
              </div>
            </li>
          </ul>
        </section>

        <section class="news-list">
          <ul v-for="(item, index) in newsList" :key="index+'newSecond'"  @click="goDetail(item)" v-show="currentPage>1">
            <li class="list-box">
              <img :src="item.pictureUrl" alt="">
              <div class="con">
                <h2>{{item.articleTitle}}</h2>
                <p>{{item.releaseTime|formatDate}}</p>
              </div>
            </li>
          </ul>
        </section>

        </div>
      </transition>
      <el-pagination
        v-if="newsList.length>0"
        @current-change="handleCurrentChange"
        class="text-c"
        background
        :pager-count="13"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  props: {
    title: {
      type: String,
      default: 'company'
    }
  },
  data () {
    return {
      titleName: this.title,
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      currentPage: 1,
      total: 0,
      newsList: [],
      newsOne: {},
      newsTwo: {},
      newsThree: {}
    }
  },
  filters: {
    formatDate: function (value) {
      const date = new Date(value)
      const y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      let m = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = this.titleName === 'pig' ? (getSession('bannerPic').wisdom_pig_farm || this.banner) : (getSession('bannerPic').enterprise_dynamics || this.banner)
    }
    if (this.currentPage === 1) {
      this.getTopArticle()
    } else {
      this.getArticlePage()
    }
  },
  methods: {
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      let obj = this.titleName === 'pig' ? arr.wisdom_pig_farm : arr.enterprise_dynamics
      obj = arr.enterprise_dynamics || {}
      this.imgSrc = this.titleName === 'pig' ? obj.picUrl : obj.picUrl
      setSession('bannerPic', arr)
    },
    /**
     * 文章列表
     */
    async getArticlePage () {
      const params = {
        currentPage: this.currentPage,
        pageSize: 8,
        state: 0,
        articleType: this.titleName === 'pig' ? 1 : 0
      }
      const res = await this.API.recruit.getArticlePage(params) || []
      this.total = res.total
      this.newsList = res.data
    },
    /** 前三条新闻 */
    async getTopArticle () {
      const params = {
        currentPage: 1,
        pageSize: 11,
        state: 0,
        articleType: this.titleName === 'pig' ? 1 : 0
      }
      const res = await this.API.recruit.getArticlePage(params) || []
      this.total = res.total
      this.newsList = res.data
      this.newsOne = res.data[0]
      this.newsTwo = res.data[1]
      this.newsThree = res.data[2]
    },
    // 分页
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.currentPage === 1) {
        this.getTopArticle()
      } else {
        this.getArticlePage()
      }
    },
    // 跳转详情
    goDetail (item) {
      this.$router.push({
        path: this.titleName === 'company' ? `/newsDetail/${item.articleId}` : `/pigDetail/${item.articleId}`,
        query: { articleId: item.articleId }
      })
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    },
    /** tab切换 */
    goTab (name) {
      this.titleName = name
      this.getBannerPage()
      if (this.currentPage === 1) {
        this.getTopArticle()
      } else {
        this.getArticlePage()
      }
    }
  }
}
</script>
